import type { MediaAssetSummary } from '@cms/contracts'
import { listMedia } from './library.js'

/**
 * Asset lookups by path, shared by every media field and thumbnail of the
 * page: an editor with a cover, an OG image and ten gallery items asks once
 * per path.
 */
const lookups = new Map<string, Promise<MediaAssetSummary | null>>()

export function findAssetByPath(siteId: string, path: string): Promise<MediaAssetSummary | null> {
  const key = `${siteId}\n${path}`
  let pending = lookups.get(key)
  if (!pending) {
    pending = listMedia(siteId, { q: path, status: 'all', limit: 10 })
      .then((page) => page.items.find((item) => item.path === path) ?? null)
      .catch(() => {
        lookups.delete(key)
        return null
      })
    lookups.set(key, pending)
  }
  return pending
}

/** An asset just chosen or uploaded is known without asking. */
export function rememberAsset(siteId: string, asset: MediaAssetSummary): void {
  lookups.set(`${siteId}\n${asset.path}`, Promise.resolve(asset))
}
